// @flow
export const UI_SET_FACET_STATE = 'ui/SET_FACET_STATE';
export const UI_RESET_FACET_STATE = 'ui/RESET_FACET_STATE';
export const UI_SET_LANG = 'ui/SET_LANG';

type State = {
  facetState: {
    platform: boolean,
    access: boolean,
    type: boolean,
    translations: boolean,
    author: boolean,
    journalsPublications: boolean,
    booksPublications: boolean,
    hypothesesPublications: boolean,
    years: boolean
  },
  lang: string
};

type Action = {
  type: string,
  payload: any
};

const initialState: State = {
  facetState: {
    platform: false,
    access: false,
    type: false,
    translations: false,
    author: false,
    journalsPublications: false,
    booksPublications: false,
    hypothesesPublications: false,
    years: true
  },
  lang: navigator.language.split(/[-_]/)[0]
};

function reducer(state: State = initialState, action: Action) {
  const { type, payload } = action;

  switch (type) {
    case UI_SET_FACET_STATE:
      return {
        ...state,
        facetState: {
          ...state.facetState,
          [payload.facet]: payload.value
        }
      };

    case UI_RESET_FACET_STATE:
      return {
        ...state,
        facetState: initialState.facetState
      };

    case UI_SET_LANG:
      return {
        ...state,
        lang: payload
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/ui.js